import Confirm from './components/Confirm/Confirm';
import { IConfigItem } from './interfaces';

export enum MODALS {
  CONFIRM = 'confirm',
}

const modalsConfig: IConfigItem[] = [
  {
    component: Confirm,
    name: MODALS.CONFIRM,
  },
];

export default modalsConfig;
